import React, { useState, useEffect, Suspense } from 'react';
import { BounceLoader } from 'react-spinners';
import moment from 'moment-timezone';


const fetchRecentRecords = () => {
  return fetch('https://surfapi.insanitygaming.net/api/history?limit=25', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }
      return response.json();
    })
    .then((data) => {
      if (data.status === 200) {
        return data.runs || [];
      }
      throw new Error('Failed to fetch data');
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      return [];
    });
};

const getRelativeTime = (utc) => {
	const runTimeStamp = moment.unix(utc).tz('America/New_York');
	console.log(runTimeStamp.toString());

	// Get the current time in New York
	const currentTime = moment().tz("America/New_York");
	console.log(currentTime.toString());

	const relativeTime = runTimeStamp.from(currentTime);
	console.log(utc);

	return relativeTime;
}


const RunBox = ({ run }) => {
  const borderColor =
    run.run_type === 0
      ? 'border-green-500'
      : run.run_type > 0
      ? 'border-blue-500'
      : 'border-yellow-500';

  const run_type_str =
    run.run_type === 0
      ? 'Main'
      : run.run_type > 0
      ? `Bonus ${run.run_type}`
      : `Stage ${Math.abs(run.run_type)}`;



  return (
    <li className={`border-2 p-4 mb-4 rounded-lg ${borderColor}`}>
      <p className="text-gray-300">
        <strong>{run.name}</strong> set a new{' '}
        <span className="text-indigo-300">{run_type_str} WR</span> on{' '}
        <span className="text-green-300">{run.map_name}</span>
      </p>
      <p className="text-gray-400 text-sm">
		{console.log(run.map_name)}
        {getRelativeTime(run.achieved_on)}
      </p>
    </li>
  );
};

const RecentRecordsList = () => {
  const [recentRecords, setRecentRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecentRecords().then((data) => {
      setRecentRecords(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
	<aside className="w-1/5 bg-gray-800 p-4 rounded-lg ml-0 h-96 sticky top-16 overflow-y-auto">
        <h3 className="text-lg font-semibold mb-4">Recent Records</h3>
        <ul className="space-y-2">
          <BounceLoader size={50} color="#4CAF50" />
        </ul>
      </aside>
    );
  }

  return (
    <aside className="w-1/5 bg-gray-800 p-4 rounded-lg ml-0 h-screen sticky top-16 overflow-y-auto">
      <h3 className="text-lg font-semibold mb-4">Recent Records</h3>
      <ul className="space-y-2">
	  {/* <RunBox key={`${recentRecords[0].user_id}-${recentRecords[0].map_id}-${0}`} run={recentRecords[0]} /> */}
        {recentRecords.map((run, idx) => (
          <RunBox key={`${run.user_id}-${run.map_id}-${idx}`} run={run} />
        ))}
      </ul>
    </aside>
  );
};

const RecentRecords = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <RecentRecordsList />
    </Suspense>
  );
};

export default RecentRecords;
